//
// generated by bin/gen_paths
//

type P = string | number;

export default {
  // alerts
  alerts_alert: (id: P) => `/alerts/${id}`, // get
  alerts_backfill: (id: P, job_id: P) => `/alerts/${id}/b/${job_id}`, // get
  alerts_create: "/create", // get|post
  alerts_destroy: (id: P) => `/destroy/${id}`, // delete
  alerts_preview: (id?: P) => `/preview${isNotNil(id) ? ('/' + id) : ''}`, // get|post
  alerts_update: (id: P) => `/edit/${id}`, // get|patch

  // auth
  auth_forgot: "/forgot", // get|post
  auth_join: (id: P) => `/join/${id}`, // get
  auth_login: "/login", // get|post
  auth_logout: "/logout", // post
  auth_oauth: (provider: P) => `/oauth/${provider}`, // get
  auth_referral: (referral_code: P) => `/r/${referral_code}`, // get
  auth_reset: "/reset", // get|post
  auth_signup: "/signup", // get|post
  auth_switch: "/switch", // post

  // billing
  billing: "/billing", // get
  billing_cancel: "/billing/cancel", // delete
  billing_pricing: "/pricing", // get|post
  billing_renew: "/billing/renew", // get|post
  billing_stripe_cancel_complete: "/billing/stripe_cancel_complete", // get
  billing_stripe_checkout_complete: "/billing/stripe_checkout_complete", // get
  billing_update_payment: "/billing/update_payment", // post

  // charts
  charts_alert_chart: (alert_id: P) => `/charts/alerts/${alert_id}.png`, // get

  // click
  click: "/c", // get

  // dash
  dash: "/dashboard", // get
  dash_referrals: "/referrals", // get
  dash_unlock: "/unlock", // get

  // home
  home_about: "/about", // get
  home_careers: "/careers", // get
  home_faq: "/faq", // get
  home_privacy: "/privacy", // get
  home_root: "/", // get
  home_tos: "/tos", // get

  // lists
  lists_destroy: (id: P) => `/lists/destroy/${id}`, // delete
  lists_list: (id: P, slug: P) => `/lists/${id}/${slug}`, // get

  // onboarding
  onboarding_create_alert: "/o/alert", // get|post
  onboarding_pick: "/o/pick", // get|post
  onboarding_plans: "/o/plans", // get|post
  onboarding_preview_alert: "/o/preview", // get|post
  onboarding_quiz: "/o/quiz", // get|post
  onboarding_stripe_checkout_complete: "/o/stripe_checkout_complete", // get
  onboarding_verify: "/o/verify", // get|post

  // settings
  settings: "/settings", // get|post
  settings_unsubscribe: "/unsubscribe", // get|post

  // asiago/alerts
  asiago_alerts_block: (id: P) => `/a/alerts/${id}/block`, // post
  asiago_alerts_block_preview: (id: P) => `/a/alerts/${id}/block_preview`, // post
  asiago_alerts_toggle_watched: (id: P) => `/a/alerts/${id}/toggle_watched`, // post
  asiago_alerts_update: (id: P) => `/a/alerts/${id}`, // patch

  // asiago/api_keys
  asiago_api_keys_create: "/a/api_keys", // post
  asiago_api_keys_destroy: (id: P) => `/a/api_keys/${id}`, // delete

  // asiago/auth
  asiago_auth_verify_resend: "/a/auth/verify_resend", // post

  // asiago/jobs
  asiago_jobs_show: (id: P) => `/a/jobs/${id}`, // get

  // asiago/lists
  asiago_lists_create: "/a/lists", // post
  asiago_lists_update: (id: P) => `/a/lists/${id}`, // patch

  // asiago/mentions
  asiago_mentions_block: (id: P) => `/a/mentions/${id}/block`, // post
  asiago_mentions_update: (id: P) => `/a/mentions/${id}`, // patch

  // asiago/team
  asiago_team_create_invite_link: "/a/team/create_invite_link", // post
  asiago_team_remove_user: "/a/team/remove_user", // delete
  asiago_team_update: "/a/team", // patch
};
